<template>
  <div class="">
    <NavEL></NavEL>
    <AdminDash></AdminDash>
  </div>
</template>

<script>
export default {
  components: {
    ...require('../kit.js').default
  }
}
</script>

<style>

</style>
